import Vue from "vue";
import { DynamicItem } from "./../interfaces/Toolbar";

export const dynamicMenu = Vue.observable({
  isFirstLoad: true,
  items: [] as DynamicItem[],
  itemsLimit: undefined as number | undefined,
  tabsSize: [] as number[],
});

export const addDynamicMenuItem = (menuId: string, newItem: DynamicItem) => {
  dynamicMenu.items.push(newItem);
  localStorage[menuId] = JSON.stringify(dynamicMenu.items);
};

export const initDynamicMenu = (menuId: string) => {
  const dynamicMenuStored = localStorage.getItem(menuId);
  if (!dynamicMenuStored) {
    localStorage.setItem(menuId, JSON.stringify(dynamicMenu.items));
  } else {
    // TODO: remove in the future (+ alert in DynamicItem interface)
    // this check is carried out due to dynamicMenu refactor
    // check if some items contain: a "name" property || a label value containing " | "
    // FYI: popups previously stored in the "name" property -OR- in the label as `${label} | ${popup}` => then .split("|")
    const dynamicMenuItems = JSON.parse(dynamicMenuStored);
    const hasOldEntries = dynamicMenuItems.some((entry: DynamicItem) => "name" in entry || entry.label.includes(" | "));
    if (hasOldEntries) {
      const cleanedDynamicMenu = dynamicMenuItems.filter(
        (entry: DynamicItem) => !("name" in entry || entry.label.includes(" | "))
      );
      localStorage[menuId] = JSON.stringify(cleanedDynamicMenu);
      dynamicMenu.items = cleanedDynamicMenu;
    } else {
      dynamicMenu.items = dynamicMenuItems;
    }
  }
};

export const replaceDynamicMenuItem = (menuId: string, item: DynamicItem, newItem: DynamicItem) => {
  const indexOfItem = dynamicMenu.items.indexOf(item);
  dynamicMenu.items.splice(indexOfItem, 1, newItem);
  localStorage[menuId] = JSON.stringify(dynamicMenu.items);
};

export const updateDynamicMenu = (menuId: string, items: DynamicItem[]) => {
  dynamicMenu.items = items;
  localStorage[menuId] = JSON.stringify(dynamicMenu.items);
};
